import AbstractService from "../../vendors/services/abstractService";
import { urlApi } from "../shared/apis/api";
import { TResponseApi } from "../../vendors/@types/httpApi";

export default class ConvidadosService extends AbstractService {
  constructor() {
    super(urlApi, "Convidados");
  }

  public async validarConvite(obj: any): Promise<TResponseApi<any>> {
    return this.api.put(`${this.rota}/validar-convite`, obj);
  }

  public async validarConviteTomadaSubsidio(obj: any): Promise<TResponseApi<any>> {
    return this.api.put(`ConvidadosEvento/validar-convite`, obj);
  }
}
